module.exports = __webpack_public_path__ + "vrbo-src-icon.png?069761975cfd4a81c06a60adee4b511e";